(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_u1-carousel-track"] && !Shopify.designMode) return;
  try {
    (function () {
    var wraps = document.querySelectorAll('[data-u1-pt-shield]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.hasAttribute('data-u1-pt-shielded')) return;
      wrap.setAttribute('data-u1-pt-shielded', '');
      var form = wrap.querySelector('form');
      if (form) {
        form.setAttribute('action', '#');
        form.classList.remove('shopify-product-form');
        form.removeAttribute('data-type');
        form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); });
      }
      /* Fase bubble: el widget ya recibio el click; solo no llega a listeners de documento (Stoq) */
      wrap.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_u1-mc-flipcard"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__u1McFlipInit) return;
    window.__u1McFlipInit = true;
    function setOpen(card, open) {
      card.classList.toggle('is-open', open);
      var btn = card.querySelector('.u1-mc-flip__toggle');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-u1-mc-flip]');
      if (!card) return;
      setOpen(card, !card.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-u1-mc-flip].is-open').forEach(function (c) {
        setOpen(c, false);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
